<template>
  <div class="footer">
      <ul class="footer__icons">
        <li><a href="#"><i class="fab fa-facebook-square"></i></a></li>
        <li><a href="#"><i class="fab fa-instagram"></i></a></li>
        <li><a href="#"><i class="fab fa-youtube"></i></a></li>
      </ul>

      <div class="footer__txt">
        <p>2020 © Capture Studio All Rights Reserved.</p>
        <p>僅做為個人學習使用，非商業用途。
          <i class="fab fa-github-alt"></i> KaiYun Cheng
        </p>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
    };
  },
};
</script>
